"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionRoutes = void 0;
const questionActions_openapi_1 = require("./questionActions.openapi");
exports.questionRoutes = [
    {
        name: 'question.list',
        path: ['/', '/q/:q'],
        method: 'GET',
        plugins: {
            openapi: questionActions_openapi_1.questionOpenApiDocs['question.list']
        }
    },
    {
        name: 'question.create',
        path: ['/'],
        method: 'POST',
        plugins: {
            openapi: questionActions_openapi_1.questionOpenApiDocs['question.create']
        }
    },
    {
        name: 'question.get',
        path: '/:id',
        method: 'GET',
        plugins: {
            openapi: questionActions_openapi_1.questionOpenApiDocs['question.get']
        }
    },
    {
        name: 'question.update',
        path: '/:id',
        method: 'PUT',
        plugins: {
            openapi: questionActions_openapi_1.questionOpenApiDocs['question.update']
        }
    },
    {
        name: 'question.delete',
        path: '/:id',
        method: 'DELETE',
        plugins: {
            openapi: questionActions_openapi_1.questionOpenApiDocs['question.delete']
        }
    }
];
